module.exports = __webpack_public_path__ + "img/dogum-saglik-sigortasi.dbc03960.png";